import React, { Fragment, useState, useEffect } from 'react';
import { Button } from 'reactstrap';

import { useGlobalState } from 'state-pool';

import SweetAlert from 'sweetalert2';

import CONTRACT_LIST from '../../contracts/contractList';

const Rightbar = (props) => {
  const [userAddressSmall] = useGlobalState('userAddressSmall');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');
  const [claimRewards, setClaimRewards] = useGlobalState('claimRewards');
  const [web3, setWeb3] = useGlobalState('Web3');
  const [userAddress] = useGlobalState('userAddress');
  const [cryptominesContract] = useGlobalState('cryptominesContract');
  const [claimTax, setClaimTax] = useGlobalState('claimTax');
  const [stoneContract] = useGlobalState('stoneContract');

  const claim = async () => {
    if (claimRewards == 0) {
      SweetAlert.fire({
        title: 'No rewards to claim.',
        icon: 'error',
      });
    } else {
      try {
        await cryptominesContract.methods
          .claimTokenRewards()
          .send({ from: userAddress })
          .once('transactionHash', function (hash) {})
          .once('receipt', function (receipt) {})
          .on('confirmation', function (confNumber, receipt) {})
          .on('error', function (error) {})
          .then(function (receipt) {
            let reward = web3.utils.fromWei(receipt.events.eventClaimRewards.returnValues['claimedAmount'], 'ether');
            let fee = web3.utils.fromWei(receipt.events.eventClaimRewards.returnValues['claimedFee'], 'ether');
            SweetAlert.fire({
              title: 'Rewards claimed.',
              text:
                'You received ' +
                parseFloat(parseFloat(reward).toFixed(3)) +
                ' ETERNAL and ' +
                parseFloat(parseFloat(fee).toFixed(3)) +
                ' ETERNAL was taxed for early claim.',
              icon: 'success',
            });
            window.gtag('event', 'claim', { value: reward, fee: fee });
          });

        const currentClaimRewards = await cryptominesContract.methods
          .getTokenRewards(userAddress)
          .call({ from: userAddress });

        const currentClaimTime = await cryptominesContract.methods.getMyTimeForClaim().call({ from: userAddress });

        let now = parseInt((Date.now() / 1000).toFixed(0));
        let remainingDays = (((currentClaimTime - now) / 86400) * 2).toFixed(2);
        if (remainingDays <= 0) {
          remainingDays = 0;
        }
        if (currentClaimRewards == 0) {
          remainingDays = 30;
        }
        setClaimTax(remainingDays);

        const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });

        setClaimRewards(web3.utils.fromWei(currentClaimRewards, 'ether'));
        setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
      } catch (error) {
        //console.log('error: ', error);
      }
    }
  };

  const addTokenWallet = async () => {
    window.gtag('event', 'addTokenWallet');
    await window.ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20',
        options: {
          address: CONTRACT_LIST['STONE_CONTRACT'],
          symbol: 'ETERNAL',
          decimals: 18,
          image: 'https://cryptomines.app/images/cryptomines-eternal-stone-metamask.png',
        },
      },
    });
  };

  return (
    <Fragment>
      <div className='nav-right col-8 pull-right right-header p-0'>
        <ul className='nav-menus'>
          <li>
            <Button
              href='https://exchange.biswap.org/#/swap?outputCurrency=0xD44FD09d74cd13838F137B590497595d6b3FEeA4'
              target='_blank'
              className='btn btn-biswap btn-pill btn-air-success'
              color='primary'
            >
              <svg viewBox='0 0 55 55' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M27.0769 54.1537C42.031 54.1537 54.1538 42.031 54.1538 27.0769C54.1538 12.1227 42.031 0 27.0769 0C12.1227 0 0 12.1227 0 27.0769C0 42.031 12.1227 54.1537 27.0769 54.1537Z'
                  fill='white'
                ></path>
                <path
                  d='M48.0498 10.187C46.1719 10.5582 44.3814 11.0823 42.9074 11.4098C39.5446 12.1632 36.4002 14.7399 35.7124 19.4565C35.101 23.6709 36.5203 25.4833 35.898 30.3855C34.8062 38.9453 26.5958 41.8931 22.7635 43.6837C20.5471 44.71 15.1645 47.0683 11.0156 48.8698C15.5139 52.1889 21.0603 54.1542 27.0762 54.1542C42.034 54.1542 54.1531 42.0351 54.1531 27.0773C54.1531 20.7011 51.9476 14.8381 48.2573 10.2198C48.1918 10.2088 48.1263 10.1979 48.0498 10.187Z'
                  fill='url(#paint0_linear)'
                ></path>
                <path
                  d='M24.0307 23.1027C26.1161 18.5935 25.3628 18.5826 26.9459 14.3464C28.9439 8.97467 35.1563 10.5032 36.8704 10.7325C39.6982 11.1146 40.4407 10.1102 46.4019 9.14936C46.6967 9.10569 46.9806 9.06202 47.2645 9.02926C42.3076 3.49379 35.1017 0 27.0769 0C16.3007 0 6.9985 6.28882 2.64218 15.4054C11.5732 17.6218 21.2139 22.4367 24.0307 23.1027ZM18.1131 4.71662C18.8992 4.83671 22.7206 9.58608 23.4412 21.7816C23.4412 21.7816 18.528 20.6024 17.469 18.0694C16.5955 15.9841 17.731 13.2436 18.1131 4.71662ZM48.2143 10.1647C48.2253 10.1866 48.2471 10.1975 48.258 10.2193C48.1925 10.2084 48.1161 10.2084 48.0506 10.1975C48.1052 10.1757 48.1598 10.1757 48.2143 10.1647ZM0 27.0769C0 24.9151 0.251116 22.8188 0.731513 20.8099C1.71414 21.6287 2.76228 22.5349 3.87593 23.5722C10.929 30.1121 22.4039 35.2764 26.5856 30.4724C26.5965 30.4833 26.6074 30.4833 26.6074 30.4942C25.8431 31.4987 22.928 34.6759 17.3598 33.6932L8.55979 46.8277C3.29727 41.8927 0 34.8724 0 27.0769Z'
                  fill='url(#paint1_linear)'
                ></path>
                <defs>
                  <linearGradient
                    id='paint0_linear'
                    x1='43.3371'
                    y1='17.2788'
                    x2='36.9491'
                    y2='52.4708'
                    gradientUnits='userSpaceOnUse'
                  >
                    <stop stopColor='#FF496A'></stop>
                    <stop offset='1' stopColor='#E42648'></stop>
                  </linearGradient>
                  <linearGradient
                    id='paint1_linear'
                    x1='13.0692'
                    y1='39.8859'
                    x2='27.193'
                    y2='-1.0612e-05'
                    gradientUnits='userSpaceOnUse'
                  >
                    <stop offset='0.00181229' stopColor='#1158F1'></stop>
                    <stop offset='1' stopColor='#119BED'></stop>
                  </linearGradient>
                </defs>
              </svg>
              <span>Buy $ETERNAL</span>
            </Button>
          </li>

          <li className='maximize'>
            <a href='#' onClick={() => addTokenWallet()}>
              Add $ETERNAL to Wallet
            </a>
          </li>
          <li className='profile-nav p-0'>
            <div className='media profile-media'>
              <img className='b-r-10' src={require('../../assets/images/logo/logo-icon.png')} alt='' />
              <div className='media-body'>
                <span>{parseFloat(stoneAmount).toFixed(3)} ETERNAL </span>
                <p className='mb-0 font-roboto'>
                  <a id='claimEternal' onClick={() => claim()} href='#'>
                    <span>CLAIM {parseFloat(claimRewards).toFixed(3)} $ETERNAL</span>
                  </a>
                </p>
                <p className='mb-0 font-roboto'>{userAddressSmall}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};
export default Rightbar;
